
    import { Component, Emit, Prop, Vue } from 'nuxt-property-decorator';
    import VueMultiselect from 'vue-multiselect/src/Multiselect.vue';

    @Component({
        components: { VueMultiselect }
    })
    export default class OptionsFieldsMultiselect extends Vue {
        @Prop() options;
        selected: Array<Object> = [];

        @Emit('input')
        onChange() {
            return this.selected;
        }

        addTag(newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
            };
            this.options.push(tag);
            this.selected.push(tag);
        }
    }
